import FontInput from '../../../../components/FontInput/FontInput'
import TextInput from '../../../../components/TextInput/TextInput'
import TextOptions from '../../../../components/TextOptions/TextOptions'
import LetterSpacingInput from '../../../../components/LetterSpacingInput/LetterSpacingInput'
import { useRef } from 'react'
import ColorInput from '../../../../components/ColorInput/ColorInput'
import Dropdown from '../../../../components/Dropdown/Dropdown'

const PlaylistEditModalTrackTab = ({
  values,
  setValue,
  onSaveClick,
  onSavePublishClick,
  publishLabel,
}) => {
  const ref = useRef()

  return (
    <div className="p-6" ref={ref}>
      <h3 className="mb-4">Track List</h3>
      <h4 className="mb-2">Text Options</h4>

      <div className="mt-4">
        <TextOptions
          label="Song Title"
          values={values.trackTitleText}
          onChange={(value) => setValue('trackTitleText', value)}
          containerRef={ref}
        />
      </div>
      <div className="mt-4">
        <TextOptions
          label="Artist"
          values={values.trackArtistText}
          onChange={(value) => setValue('trackArtistText', value)}
          containerRef={ref}
        />
      </div>
      <div className="mt-4">
        <TextOptions
          label="Album"
          values={values.trackAlbumText}
          onChange={(value) => setValue('trackAlbumText', value)}
          containerRef={ref}
        />
      </div>
      <div className="mt-4">
        <TextOptions
          label="Duration"
          values={values.trackDurationText}
          onChange={(value) => setValue('trackDurationText', value)}
          containerRef={ref}
        />
      </div>
      <h4 className="mb-2 mt-8">Track Row</h4>

      <div className="mt-4">
        <ColorInput
          label="Play Button Color"
          value={values.trackPlayButtonColor}
          containerRef={ref}
          onChange={(value) => setValue('trackPlayButtonColor', value)}
        />
      </div>
      <div className="mt-4">
        <ColorInput
          label="Background Color"
          value={values.trackBackground}
          containerRef={ref}
          onChange={(value) => setValue('trackBackground', value)}
        />
      </div>
      <div className="mt-4">
        <ColorInput
          label="Background Color (hover)"
          value={values.trackBackgroundHover}
          containerRef={ref}
          onChange={(value) => setValue('trackBackgroundHover', value)}
        />
      </div>

      <h4 className="mb-2 mt-8">Album Art</h4>

      <div className="mt-4 ">
        <Dropdown
          label="Album Art Size"
          options={[
            { id: '', name: 'Hidden' },
            { id: 'small', name: 'Small' },
            { id: 'normal', name: 'Normal' },
            { id: 'large', name: 'Large' },
          ]}
          value={values.trackArtSize}
          onChange={(val) => setValue('trackArtSize', val)}
        ></Dropdown>
      </div>
      <h4 className="mb-2 mt-8">Progress Bars</h4>

      <div className="mt-4">
        <Dropdown
          label="Individual Track Progress Bars"
          options={[
            { id: 0, name: 'Hidden' },
            { id: 1, name: 'Visible' },
          ]}
          value={values.showTrackProgressBar}
          onChange={(val) =>
            setValue('showTrackProgressBar', parseInt(val, 10))
          }
        ></Dropdown>
      </div>

      <h3 className="mb-4 mt-8">Metadata</h3>

      <div className="mt-4">
        <TextOptions
          label="Label"
          values={values.metadataLabelText}
          onChange={(value) => setValue('metadataLabelText', value)}
          containerRef={ref}
        />
      </div>
      <div className="mt-4">
        <TextOptions
          label="Value"
          values={values.metadataValueText}
          onChange={(value) => setValue('metadataValueText', value)}
          containerRef={ref}
        />
      </div>
      <div className="mt-4 ">
        <Dropdown
          label="Album Art Size"
          options={[
            { id: '', name: 'Hidden' },
            { id: 'small', name: 'Small' },
            { id: 'normal', name: 'Normal' },
            { id: 'large', name: 'Large' },
          ]}
          value={values.metadataArtSize}
          onChange={(val) => setValue('metadataArtSize', val)}
        ></Dropdown>
      </div>

      <div className="mt-10 mb-4">
        <button
          className="button bg-pink hover:bg-pink-off"
          onClick={onSaveClick}
        >
          Save
        </button>
        <button
          className="button ml-4 text-white-dark"
          onClick={onSavePublishClick}
        >
          {publishLabel}
        </button>
      </div>
    </div>
  )
}

export default PlaylistEditModalTrackTab
